import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Chatbot from "@/components/Chatbot";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import NewTaskPage from "@/pages/NewTaskPage";
import TaskDetailPage from "@/pages/TaskDetailPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminPage from "@/pages/AdminPage";
import AdminPartnersPage from "@/pages/AdminPartnersPage";
import AccountSettingsPage from "@/pages/AccountSettingsPage";
import PartnersPage from "@/pages/PartnersPage";
import PartnerApplyPage from "@/pages/PartnerApplyPage";
import PartnerDashboardPage from "@/pages/PartnerDashboardPage";
import PartnerProfilePage from "@/pages/PartnerProfilePage";
import RecentWorkPage from "@/pages/RecentWorkPage";
import PublicQuotePage from "@/pages/PublicQuotePage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookieConsent from "@/components/CookieConsent";

function App() {
    return (
        <div className="min-h-screen bg-[#0B1220] text-slate-100">
            <BrowserRouter>
                <AuthProvider>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
                        <Route path="/tasks/new" element={<ProtectedRoute><NewTaskPage /></ProtectedRoute>} />
                        <Route path="/tasks/:id" element={<ProtectedRoute><TaskDetailPage /></ProtectedRoute>} />
                        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
                        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
                        <Route path="/admin/partners" element={<ProtectedRoute adminOnly><AdminPartnersPage /></ProtectedRoute>} />
                        <Route path="/account" element={<ProtectedRoute><AccountSettingsPage /></ProtectedRoute>} />
                        <Route path="/partners" element={<PartnersPage />} />
                        <Route path="/partners/apply" element={<PartnerApplyPage />} />
                        <Route path="/partner" element={<ProtectedRoute><PartnerDashboardPage /></ProtectedRoute>} />
                        <Route path="/partner/profile" element={<ProtectedRoute><PartnerProfilePage /></ProtectedRoute>} />
                        <Route path="/recent-work" element={<RecentWorkPage />} />
                        <Route path="/pricing" element={<PublicQuotePage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                    </Routes>
                    <Chatbot />
                    <CookieConsent />
                    <Toaster richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
